// Guards against 0-price poisoning of the POS catalog and the cachedProducts
// localStorage overlay. Branches with a secondary price list can have items whose
// branch row holds no (primary-list) price — a realtime message or API response
// carrying that 0 must never overwrite or shadow a correct price.

export function hasPositivePrice(product) {
    if (!product) return false;
    const n = Number(product.Price);
    return Number.isFinite(n) && n > 0;
}

// Price coming from a realtime (SignalR) payload: returns the numeric price to
// apply, or undefined when the value is absent/invalid and must be ignored.
// An explicit 0 IS applied: the backend only sends it when the item's price was
// genuinely removed — the POS shows the item at $0 and checkout is blocked.
export function realtimePriceToApply(payloadPrice) {
    if (payloadPrice === undefined || payloadPrice === null || payloadPrice === '') return undefined;
    const n = Number(payloadPrice);
    return Number.isFinite(n) && n >= 0 ? n : undefined;
}

// Scan resolution: the cached overlay wins only when it carries a usable price;
// otherwise the catalog entry (fed by the generated item file) is safer.
export function pickScanProduct(cachedProduct, catalogProduct) {
    if (cachedProduct && catalogProduct) {
        return hasPositivePrice(cachedProduct) ? cachedProduct : catalogProduct;
    }
    return cachedProduct ?? catalogProduct ?? null;
}
